module.exports = "https://www.gc-pro.gnp.com.mx/e79d2ef24b687dcb7d3b9598e1d01854.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-hist-rico.svg
// module id = 1829
// module chunks = 0